import BaseAuthors from './onboarding/onboarding_steps/BaseAuthors';

export default function BootstrappingPage() {

  return (
    <BaseAuthors />
  )
}